import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=3175e5e4&scoped=true"
import script from "./Body.vue?vue&type=script&lang=js"
export * from "./Body.vue?vue&type=script&lang=js"
import style0 from "./Body.vue?vue&type=style&index=0&id=3175e5e4&prod&lang=scss&scoped=true"
import style1 from "./Body.vue?vue&type=style&index=1&id=3175e5e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3175e5e4",
  null
  
)

export default component.exports